var _excluded = ["text", "typography", "gutterSpace", "emphasis", "onChange", "isChecked", "hasError"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
import RadioButtonAtm from "../../atoms/RadioButtonAtm";
import RichTextMol from "../RichTextMol";
export var defaultProps = {
  gutterSpace: {
    small: 1,
    mediumUp: 2
  }
};
var gutterBasicStyles = function gutterBasicStyles($gutterSpace) {
  if ($gutterSpace.small) {
    return css(["> :first-child{margin-right:", ";}", "{> :first-child{margin-right:", ";}}"], space($gutterSpace.small), breakpoint("medium"), space($gutterSpace.mediumUp));
  }
  return css(["> :first-child{margin-right:", ";}"], space($gutterSpace));
};
var StyledLabel = styled.label.withConfig({
  componentId: "sc-hj0hw5-0"
})(function (_ref) {
  var _ref$$gutterSpace = _ref.$gutterSpace,
    $gutterSpace = _ref$$gutterSpace === void 0 ? defaultProps.gutterSpace : _ref$$gutterSpace;
  return css(["", ";display:flex;align-items:center;cursor:pointer;> :first-child{flex-shrink:0;}"], gutterBasicStyles($gutterSpace));
});
function RadioButtonWithLabelMol(_ref2) {
  var text = _ref2.text,
    typography = _ref2.typography,
    _ref2$gutterSpace = _ref2.gutterSpace,
    gutterSpace = _ref2$gutterSpace === void 0 ? defaultProps.gutterSpace : _ref2$gutterSpace,
    emphasis = _ref2.emphasis,
    onChange = _ref2.onChange,
    isChecked = _ref2.isChecked,
    hasError = _ref2.hasError,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledLabel, _extends({
    $gutterSpace: gutterSpace
  }, restProps), /*#__PURE__*/React.createElement(RadioButtonAtm, {
    onChange: onChange,
    isChecked: isChecked,
    hasError: hasError
  }), /*#__PURE__*/React.createElement(RichTextMol, {
    data: text,
    typography: typography,
    emphasis: emphasis
  }));
}
export default RadioButtonWithLabelMol;